const axios = require('axios')

let baseUrl = null
let instance = null
let frontEndBaseURL = null
let clientBaseUrl = null

if (process.env.NODE_ENV === "production") {
    clientBaseUrl = 'https://asg-quote-generator.herokuapp.com'
    baseUrl = '/api'
    instance = axios.create({baseURL: '/api/'})
    frontEndBaseURL = ''
}

if (process.env.NODE_ENV === "development") {
    clientBaseUrl = 'http://localhost:3000'
    baseUrl = 'http://localhost:3000/api'
    instance = axios.create({baseURL: 'http://localhost:3000/api/'})
    frontEndBaseURL = 'http://localhost:3000'
}

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401 &&
            error.response.data && error.response.data.forceLogin) {
            document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;'
            const currentPath = window.location.pathname + window.location.search
            window.location.href = currentPath.startsWith('/account/login')
                ? '/account/login'
                : '/account/login?redirect=' + encodeURIComponent(currentPath)
            return new Promise(() => {})
        }
        return Promise.reject(error)
    }
)

export { instance, baseUrl, frontEndBaseURL, clientBaseUrl }
